import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  Modal,
  Row,
  Col,
  ModalHeader,
  ModalBody,
  CardFooter,
} from 'reactstrap';
import {
  useFetch,
  Form,
  Field,
  Button,
} from '@cordata/buffet';
import emailHref from '~/utils/email/emailhref';
import serviceReferral from '~/utils/email/templates/serviceReferral';
import ServiceReferralConfirmation from './Confirmation';

const emailLink = (values) => {
  const cc = `${values.wkrEmail};${values.supEmail}`;
  const body = serviceReferral(values);
  return emailHref({
    to: '', subject: values.subject, body, cc,
  });
};

const ServiceReferralEmailModal = ({
  patientUid,
  isOpen,
  toggleIsOpen,
}) => {
  const [, data] = useFetch('data/public/list-view-cs-tbl-ref-email', {
    params: {
      patient_uid: patientUid,
    },
    initialState: [],
    instance: 'p',
  });
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const modalToggle = () => {
    setConfirmationOpen(false);
    toggleIsOpen();
  };
  return (
    <Modal isOpen={isOpen} toggle={modalToggle} size="xl">
      <ModalHeader toggle={modalToggle}>Service Referral Email</ModalHeader>

      <ModalBody className="p-0">
        <Card header={false} body={false} footer={false}>
          { data && data[0]
            ? (
              <Form
                initialValues={{
                  ...data[0].attributes,
                    subject: `Child in ${data[0].attributes.county} custody - Service Referral`,
                    additionalMessage: undefined,
                    childName: `${data[0].attributes.lastName}, ${data[0].attributes.firstName}`,
                }}
              >
                {({
                  values,
                }) => (
                  <>
                    <CardBody>
                      <Row form>
                        <Col sm>
                          <Field name="wkrEmail" label="Case Worker's Email" />
                        </Col>

                        <Col sm>
                          <Field name="supEmail" label="Supervisor's Email" />
                        </Col>
                      </Row>

                      <Field name="subject" disabled />

                      <Field name="additionalMessage" type="textarea" placeholder="Additional Information" />

                      <Row form>
                        <Col sm>
                          <Field name="childName" disabled />
                        </Col>

                        <Col sm>
                          <Field name="birthDate" disabled />
                        </Col>
                      </Row>

                      <Field name="csChildLegalStatusCustody" label="Custody Status" disabled />

                      <Row form>
                        <Col sm>
                          <Field name="personId" label="SACWIS Person ID" disabled />
                        </Col>

                        <Col sm>
                          <Field name="caseId" label="SACWIS Case ID" disabled />
                        </Col>
                      </Row>

                      <Row form>
                        <Col sm>
                          <Field name="county" label="Caseworker County" disabled />
                        </Col>

                        <Col sm>
                          <Field name="wkrName" label="Caseworker Name" disabled />
                        </Col>
                      </Row>

                      <Row form>
                        <Col sm>
                          <Field name="providerName" label="Caregiver Name" disabled />
                        </Col>

                        <Col sm>
                          <Field name="providerContact" label="Caregiver Phone Number" disabled />
                        </Col>
                      </Row>

                      <Field name="providerAddress" label="Caregiver Address" disabled />

                      <Field name="placementType" disabled />

                      <Row form>
                        <Col sm>
                          <Field name="providerAgency" label="Placement Agency" disabled />
                        </Col>

                        <Col sm>
                          <Field name="providerAgencyContact" Label="Placement Agency Phone Number" disabled />
                        </Col>
                      </Row>
                    </CardBody>

                    <CardFooter className="d-flex">
                      <div className="ml-auto">
                        <Button type="cancel" onClick={modalToggle}>
                          Cancel
                        </Button>

                        <Button type="link" color="primary" onClick={() => { setConfirmationOpen(true); }}>
                          Generate Email
                        </Button>

                        <ServiceReferralConfirmation
                          isOpen={confirmationOpen}
                          toggleIsOpen={modalToggle}
                          emailHref={emailLink(values)}
                        />
                      </div>
                    </CardFooter>
                  </>
                )}
              </Form>
            ) : (
              <div>
                The Service Referral email cannot find an email recipient and cannot send.{' '}
                All foster care workers associated with this record are currently missing{' '}
                an email address.
              </div>
            )}
        </Card>
      </ModalBody>
    </Modal>
  );
};

ServiceReferralEmailModal.propTypes = {
  patientUid: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleIsOpen: PropTypes.func.isRequired,
};

export default ServiceReferralEmailModal;
